module.exports = function createAdmin(loadUsers) {
  return {
    state: { loading: false, error: false, users: [], totalUsers: 0, pagination: { page: 1, limit: 10, total: 0 } },
    getters: { totalPages: state => state.pagination.total },
    mutations: {
      loading(state) { state.loading = true; state.error = false; state.users = []; },
      ready(state, data) { state.users = data.users; state.totalUsers = data.total; state.pagination.total = Math.ceil(data.total / 10); },
      failed(state) { state.error = true; },
      finished(state) { state.loading = false; },
      page(state, page) { state.pagination.page = page; }
    },
    actions: {
      async getUsers({commit, state}) {
        commit('loading');
        try { commit('ready', await loadUsers(state.pagination.page)); }
        catch (error) { commit('failed'); }
        finally { commit('finished'); }
      },
      async paginate({commit, dispatch}, page) { commit('page', page); await dispatch('getUsers'); }
    }
  };
};
